import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useContext } from 'react';
import type { HTMLTagProps } from '../../../../types';
import { BottomDrawerContext } from '..';
type BottomDrawerHandleWrapperProps = HTMLTagProps<'div'>;
export const HandleWrapper = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let restProps;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = restProps;
  } else {
    children = $[1];
    className = $[2];
    restProps = $[3];
  }
  const context = useContext(BottomDrawerContext);
  if (!context) {
    throw new Error("BottomDrawer.HandleWrapper\uB294 BottomDrawer \uB0B4\uBD80\uC5D0\uC11C\uB9CC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.");
  }
  let t1;
  if ($[4] !== children || $[5] !== className || $[6] !== context.onClose || $[7] !== context.swipeableHandlers || $[8] !== restProps) {
    t1 = context.onClose ? <div {...restProps} {...context.swipeableHandlers} className={cn("relative flex w-full justify-center px-8 pb-12 pt-8", className)}>{children}</div> : <div className="relative h-36 w-full" />;
    $[4] = children;
    $[5] = className;
    $[6] = context.onClose;
    $[7] = context.swipeableHandlers;
    $[8] = restProps;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};